import type { Types } from 'mongoose';

export enum VectorStoreStatusEnum {
  ACTIVE = 'active',
  PROCESSING = 'processing',
  FAILED = 'failed',
}

export interface DocumentChunk {
  content: string;
  embedding: number[];
  metadata: {
    filename: string;
    s3Key?: string;
    chunkIndex: number;
    totalChunks: number;
    _id: Types.ObjectId;
  };
}

export interface VectorStore {
  _id: Types.ObjectId;
  name: string;
  description?: string;
  fileCount: number;
  chunkCount: number;
  status: VectorStoreStatusEnum;
  s3IndexKey?: string;
  s3Bucket?: string;
  chunks: DocumentChunk[];
  createdBy?: Types.ObjectId;
  metadata?: Record<string, unknown>;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateVectorStoreParams {
  name: string;
  description?: string;
  files?: unknown[];
  createdBy: Types.ObjectId;
  metadata?: Record<string, unknown>;
}

export interface QueryVectorStoreParams {
  vectorStoreId: string;
  query: string;
  topK?: number;
}

export interface VectorStoreFile {
  filename: string;
  s3Key: string;
  bytes: number;
  chunkCount: number;
  createdAt: Date;
}

export interface RAGChatOptions {
  model?: string;
  temperature?: number;
  topP?: number;
  maxTokens?: number;
  systemPrompt?: string;
  stream?: boolean;
}

export interface RAGQueryResult {
  chunks: Array<{
    content: string;
    metadata?: Record<string, unknown>;
  }>;
  sources: string[];
}

export interface RAGChatResult {
  content: string;
  model: string;
  usage?: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
  sources: string[];
}
